import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSwitcher.css";

interface LanguageSwitcherProps {
  style?: React.CSSProperties;
  size?: "small" | "middle" | "large";
}

const LANGUAGES: Array<{ code: string; short: string; label: string }> = [
  { code: "en", short: "EN", label: "English" },
  { code: "es-US", short: "ES", label: "Español" },
];

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ style, size }) => {
  // @ts-ignore - useTranslation with namespace parameter
  const { i18n } = useTranslation("common");
  const [selectedLang, setSelectedLang] = useState<string>(
    i18n.language.startsWith("es") ? "es-US" : "en",
  );

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      setSelectedLang(lng.startsWith("es") ? "es-US" : "en");
    };
    i18n.on("languageChanged", handleLanguageChanged);
    return () => i18n.off("languageChanged", handleLanguageChanged);
  }, [i18n]);

  const handleLanguageChange = (value: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set("language", value);
    window.history.replaceState({}, "", url.toString());
    localStorage.setItem("i18nextLng", value);
    setSelectedLang(value);
    i18n.changeLanguage(value);
  };

  return (
    <div
      className={`language-switcher${
        size === "small" ? " language-switcher--sm" : ""
      }`}
      role="group"
      aria-label="Language"
      style={style}
    >
      {LANGUAGES.map((lang) => {
        const isActive = selectedLang === lang.code;
        return (
          <button
            key={lang.code}
            type="button"
            className={`language-switcher__option${
              isActive ? " is-active" : ""
            }`}
            aria-pressed={isActive}
            aria-label={lang.label}
            onClick={() => handleLanguageChange(lang.code)}
          >
            {lang.short}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
